<p-dialog [contentStyle]="{'overflow':'auto'}" [styleClass]="'sm:col-12 md:col-6 lg:col-5 xl:col-4'" [(visible)]="visible" [modal]="true" [closable]="true" (onHide)="close($event)">
    <ng-template pTemplate="header">
        <span class="p-dialog-title">            
            {{'Export_Doc' | translate}}
        </span>
    </ng-template>

    <div class="col-12 md:col-12 align">
        <span>{{tools.getSelectdedCount(selectedDocs.length)}}</span>
    </div>

    <div class="col-12 p-field-radiobutton">
        <p-radioButton name="group1" value="optpdf" [(ngModel)]="selectedValueExport" inputId="opt1">
        </p-radioButton>
        <label for="opt1" class="ml-2">{{'Export_Pdf' | translate}}</label>
    </div>
    <div class="col-12 p-field-radiobutton">
        <p-radioButton name="group1" value="optzip" [(ngModel)]="selectedValueExport" inputId="opt2">
        </p-radioButton>
        <label for="opt2" class="ml-2">{{'Export_ZPdf' | translate}}</label>
    </div>
    <div class="col-12 p-field-radiobutton">
        <p-radioButton name="group1" value="optori" [(ngModel)]="selectedValueExport" inputId="opt3">
        </p-radioButton>
        <label for="opt3" class="ml-2">{{'Export_ZOri' | translate}}</label>
    </div>
    <div class="col-12 p-field-radiobutton">
        <p-radioButton name="group1" value="optzdoc" [(ngModel)]="selectedValueExport" inputId="opt4">
        </p-radioButton>
        <label for="opt4" class="ml-2">{{'Export_ZZdoc' | translate}}</label>
    </div>
    
    <ng-template pTemplate="footer">
        <button class="margin" pButton type="button" (click)="onClickExecExport()" label="{{'Run' | translate}}"></button>
    </ng-template>
</p-dialog>
